<div class="vault-submit atmos-card">
  <div class="atmos-card__header">
    <h2 class="atmos-section__title">Add outfit</h2>
  </div>
  <div class="atmos-card__body">
    <!-- Selection preview -->
    <div class="selection-icons">
      @for (type of selectionTypes; track type) {
        @let item = selection()[type];
        <div class="selection-icon is-static"
          [class.selected]="item"
          [class.warn]="requiredParams[type] && !item"
          [skyTooltip]="item?.name || (type | itemType)">
          @if (item) {
            <app-item-icon [item]="item" [size]="'default'" class="selection-icon-img"
              [opaque]="true"></app-item-icon>
          } @else {
            <mat-icon [svgIcon]="itemIcons[type]" class="selection-icon-img"></mat-icon>
          }
        </div>
      }
    </div>

    @if (!hasRequiredItems()) {
      <div class="vault-submit__warning">
        You have not selected a full outfit. Some required items are missing.<br/>
        If necessary, please submit multiple versions (i.e. multiple capes) individually instead of leaving the item blank.
      </div>
    }

    @if (!submitUnderstood()) {
      <div class="vault-submit__intro">
        <p class="atmos-paragraph">
          By submitting an outfit to the vault other players will be able to find it on this page.
        </p>
        <ul class="vault-submit__list">
          <li>Please make sure you select <b>all</b> items used in the outfit.</li>
          <li>If a message or collage contains multiple outfits, please submit them separately.</li>
          <li>If you think you did something wrong you can contact Silverfeelin on Discord.</li>
        </ul>
        <div>
          <button type="button" class="atmos-btn atmos-btn--sm" (click)="submitUnderstood.set(true)">
            <mat-icon>done</mat-icon>
            <span>I understand</span>
          </button>
        </div>
      </div>
    }

    @if (submitUnderstood()) {
      <div class="vault-submit__form">
        <!-- Link -->
        <div class="vault-submit__field">
          <label for="txtDiscordLink">
            Discord message link:
            <span class="atmos-text-link" skyTooltip="To copy the &quot;Message Link&quot;, right click or long press the Discord message that contains the pictures.">(help)</span>
          </label>
          <input id="txtDiscordLink" type="text" class="atmos-input"
            [value]="sDiscordLink()"
            (input)="onDiscordLinkChange($any($event.target).value)"
            autocomplete="off">
          <div class="vault-submit__verify">
            <span class="atmos-page__hint">Please verify the link works before submitting!</span>
            @if (pDiscordLink()) {
              <div class="vault-submit__verify-links">
                <a class="atmos-btn atmos-btn--sm" [href]="pDiscordLink()">
                  <mat-icon>open_in_browser</mat-icon>
                  <span>Open in Discord</span>
                </a>
                <a class="atmos-btn atmos-btn--sm" [href]="sDiscordLink()" target="_blank" rel="noopener">
                  <mat-icon>link</mat-icon>
                  <span>Open in browser</span>
                </a>
              </div>
            }
          </div>
        </div>

        <!-- Size -->
        <div class="vault-submit__field">
          <label for="selSize">Size:</label>
          <select id="selSize" class="atmos-input" [value]="sSize()" (change)="sSize.set($any($event.target).value)">
            <option value="0"></option>
            @for (size of sizes; track $index) {
              @if ($index > 0) {
                <option [value]="$index">{{ size }}</option>
              }
            }
          </select>
        </div>

        <!-- Lighting -->
        <div class="vault-submit__field">
          <label for="selLight">Lighting:</label>
          <select id="selLight" class="atmos-input" [value]="sLight()" (change)="sLight.set($any($event.target).value)">
            <option value="0"></option>
            @for (light of lightings; track $index) {
              @if ($index > 0) {
                <option [value]="$index">{{ light }}</option>
              }
            }
          </select>
        </div>

        <!-- Submit -->
        <div>
          <button type="button" class="atmos-btn atmos-btn--sm" (click)="onSubmit()">
            <mat-icon>send</mat-icon>
            <span>Submit</span>
          </button>
        </div>
      </div>
    }
  </div>
</div>
